module.exports = __webpack_public_path__ + "static/media/transporteDeBase.bfc2ae61.png";